import { JointCertProgramInstallComponent } from './components';
import { useProgramInstall } from './hooks/useProgramInstall';

export const DelfinoG3Component: React.FC<ReturnType<typeof useProgramInstall>> = (props) => {
  return <>{props.popup.isOpen && <JointCertProgramInstallComponent {...props} />}</>;
};
